import styled from "styled-components";

export const PageContentContainerStyle = styled.div`
    p{
        text-align: left;
    }

    width: 100%;
    padding: 1.5rem;
`;
